import { Dimension } from "@/services/dimension/dimension.model"
import { Select, InputNumber } from "antd"
import { KeyboardEvent, useEffect, useRef, useState } from "react"
import { toUnitValFromUnit } from "../FlowSheetEditor/components/RightPanel/UnitPanel/components/common/utils"
import { filter, merge, skip, takeUntil, tap, throttleTime } from "rxjs"
import { useSubject } from "@/hooks/useSubject"
import { useEvent$ } from "@/hooks/useEventObserverable"


export interface NumberInputWithUnitPropps {
  units: Dimension.Unit[]
  unit: Dimension.Unit
  onEnd?: (val: number | undefined) => void
  value?: number
}

export const NumberInputWithUnit = (props: NumberInputWithUnitPropps) => {
  const {value: initVal, onEnd, units, unit} = props

  const [value, setValue] = useState(initVal)
  const [unitId, setUnitId] = useState(unit?.id)
  const inputSubmitEvent$ = useSubject()
  const keyEvent$ = useEvent$<KeyboardEvent>('keydown')
  const outClick$ = useEvent$('click')
  const modalValRef = useRef({value, unitId})
  modalValRef.current = {value, unitId}

  useEffect(() => {
    const submit$ = keyEvent$.pipe(filter(item => {
      return item.code === 'Enter' || item.code === 'Tab';
    }))
    const cancel$ = keyEvent$.pipe(filter(item => item.code === 'Escape'), tap(() => {
      onEnd?.(initVal)
    }))

    const sub = merge(submit$, outClick$.pipe(skip(1)), inputSubmitEvent$)
    .pipe(takeUntil(cancel$), throttleTime(400))
    .subscribe(() => {
      const {value, unitId} = modalValRef.current
      console.log(unitId)
      if (unit?.id === unitId) {
        return onEnd?.(value)
      }

      if (!value) {
        return onEnd?.(value)
      }
      const newUnit = units.find(item => item.id === unitId)!
      const newVal = toUnitValFromUnit(value, newUnit, unit)
      return onEnd?.(newVal)
    })

    return () => {
      sub.unsubscribe()
    }

  }, [outClick$, keyEvent$, modalValRef, initVal, onEnd, units, unit])

  useEffect(() => {
    setValue(initVal)
  }, [initVal])

  useEffect(() => {
    setUnitId(unit?.id)
  }, [unit])

  const onUnitChange = (uId: number) => {
    setUnitId(uId)
    modalValRef.current = {value, unitId: uId}
    inputSubmitEvent$.next('')
  }

  const onValChange = (val) => {
    setValue(val)
  }

  const afterContent = units.length > 0 ? <Select value={unitId} onChange={onUnitChange} style={{ width: 70 }}>
    {units.map((u) => (
      <Select.Option key={u.id} value={u.id}>
        {u.code}
      </Select.Option>
    ))}
  </Select> : null

  return (
    <div className="flex-center" onClick={(e) => {
      e.nativeEvent.stopPropagation()
    }}>
      <InputNumber
        value={value}
        onChange={onValChange}
        controls={false}
        onBlur={() => {
          modalValRef.current = {value, unitId}
        }}
        style={{ width: 180 }}
        addonAfter={afterContent}
      />
    </div>
  );

}